import { createSelector } from 'reselect';
import CarditResditBestPracticeElementsColumns from '../../containers/CarditResditBestPracticeElementsColumns';

// eslint-disable-next-line max-len
export const getGeneratedOnDateTime = state => state.reporting.CARDIT_RESDIT_BEST_PRACTICE_ELEMENTS_106.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.CARDIT_RESDIT_BEST_PRACTICE_ELEMENTS_106.isLoading;

export const getData = state => state.reporting.CARDIT_RESDIT_BEST_PRACTICE_ELEMENTS_106.data;

export const getColumns = createSelector(
  getData,
  state => state.userData.userType,
  CarditResditBestPracticeElementsColumns,
);
